import { AxiosResponse } from 'axios';

import { get, post, put, remove } from 'services/api';
import { IPermissionsFormData } from 'views/PermissionsView/components/PermissionsForm/types';

export const getAll = (
  limit: number,
  page: number,
  search: string,
  sortKey: string,
  sortType: string,
): Promise<AxiosResponse> =>
  get(
    `permissions?limit=${limit}&page=${page}&search=${search}&sortKey=${sortKey}&sortType=${sortType}`,
  );

export const getOne = (id: string): Promise<AxiosResponse> => get(`permissions/${id}`);

export const save = (formData: IPermissionsFormData, id: string): Promise<AxiosResponse> =>
  !id ? post('permissions', formData) : put(`permissions/${id}`, formData);

export const softDelete = (id: string): Promise<AxiosResponse> => remove(`permissions/${id}`);
